import { t } from 'i18next';
import React, { type FC } from 'react';
import { Link } from 'react-daisyui';
import { navigationData } from '../../../../../data';
import type { SideBarProps } from './types';

const Sidebar: FC<SideBarProps> = ({ isOpen, displaySearch }) => {
    const navigations = navigationData.headerNavigations;

    return (
        <div
            className={`
                bg-white fixed shadow-sm w-72 h-full left-0 
                z-10 transition-transform ease-in
                ${isOpen ? 'translate-x-0' : '-translate-x-72'}
                ${displaySearch ? 'sm:mt-16 max-sm:top-12 sm:top-0 bottom-0' : 'mt-16 '}
                `}
        >
            <div>
                {navigations.map((item, index) => (
                    <div key={`navigation-item-${index + 1}`} className={'text-black active:bg-blue'}>
                        <Link
                            href={`${item.path}`}
                            className={`decoration-inherit text-inherit block py-3 pr-14 pl-5 transition-colors 
                                    hover:transition-colors ease-in hover:bg-blue hover:text-white hover:no-underline`}
                        >
                            {`${t(item.title, item.defaultTitle)}`}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Sidebar;
